<div class="additional-xrays">
  <div class="additional-xrays-section">
    <div class="heading">
      Upload Additional Image(s)
      <span class="badge bg-success">{{ studyFiles.length }}</span>
    </div>

    <div class="row">
      <div *ngFor="let studyFile of studyFiles" class="col-md-2">
        <div class="xray-wrapper">
          <app-xray-item
            [studyFile]="studyFile"
            [mediaCategories]="mediaCategories"
             [mediaGroups]="mediaGroups"
            [viewonly]="viewonly"
            (viewImage)="viewImage($event)"
            (changeCategoryClicked)="emitChangeMediaCategory($event)"
            (uploadAdditionalClicked)="emitUploadAsAdditional($event)"
            (deleteStudyFileClicked)="emitDeleteStudyFile($event)"
          ></app-xray-item>
        </div>
      </div>

      <ng-container *ngIf="!viewonly">
        <div class="col-md-2" *ngFor="let file of selectedFiles">
          <div class="xray-wrapper">
            <div
              class="outlay-outer flex align-items-center justify-content-center"
            >
              <div class="flex align-items-center justify-content-center">
               
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <app-upload-file
            [disabled]="selectedFiles.length > 0"
            (uploadFiles)="selectFiles($event)"
          ></app-upload-file>
        </div>
      </ng-container>
    </div>
  </div>
</div>
